<template>
<h1><font-awesome-icon icon="radiation" /></h1>
<u>Geiger-Müller-Zähler</u>
<br>
<SemiGauge id="geiger" :value="Dosisleistung" :min="0.01" :max="10" :log="true" unit="µSv/h"
           :zones="ZONES" :ticks="TICKS" />
<b>{{ valid ? Dosisleistung : '--' }}</b> &micro;Sv/h
<div v-if="level"><b>{{ level.name }}</b></div>
<br>
aktuelle Aktivität: <b>{{Aktivitaet}}</b> cpm
<br><br>
Empfindlichkeit <b>{{Sensitivitaet}} cpm/&micro;Sv/h</b>
</template>

<script>
import SemiGauge from './semi_gauge.vue'

// logarithmic scale 0.01 .. 10 µSv/h: [from, to, color]
const ZONES = [
  [0.01, 0.3, '#22a447'],
  [0.3, 1, '#f2d400'],
  [1, 3, '#f08a00'],
  [3, 10, '#d82a1f']
]

const TICKS = []
for (const decade of [0.01, 0.1, 1]) {
  TICKS.push({ v: decade, size: 'major', label: String(decade) })
  TICKS.push({ v: decade * 2, size: 'mid' })
  TICKS.push({ v: decade * 5, size: 'mid' })
}
TICKS.push({ v: 10, size: 'major', label: '10' })

// upper bound (exclusive) of each zone
const LEVELS = [
  { below: 0.3, name: 'normal' },
  { below: 1, name: 'erhöht' },
  { below: 3, name: 'hoch' },
  { below: Infinity, name: 'gefährlich' }
]

export default {
  name: 'GeigerCounter',
  components: { SemiGauge },
  props: {
    Dosisleistung: Number,
    Aktivitaet: Number,
    Sensitivitaet: Number
  },
  data() {
    return { ZONES, TICKS }
  },
  computed: {
    valid() {
      return Number.isFinite(this.Dosisleistung)
    },
    level() {
      return this.valid ? LEVELS.find(l => this.Dosisleistung < l.below) : null
    }
  }
}
</script>
